// ═══════════════════════════════════════════════════════════════════════════════
// PWA / standalone display detection (shared across layout, push, install prompt)
// ═══════════════════════════════════════════════════════════════════════════════

export const isRunningAsPwa = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const displayModeStandalone = window.matchMedia('(display-mode: standalone)').matches;
  const displayModeFullscreen = window.matchMedia('(display-mode: fullscreen)').matches;
  const iosStandalone = (window.navigator as Navigator & { standalone?: boolean }).standalone === true;

  return displayModeStandalone || displayModeFullscreen || iosStandalone;
};

/** iPhone / iPad home-screen PWA (keyboard viewport behavior differs from Android). */
export const isIosMobilePwa = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }
  if (!isRunningAsPwa()) {
    return false;
  }
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};
